export enum ProfileRoutes {
  ID = ':id',
  EDIT = 'edit',
  CONTACT = 'contact',
  REFERRAL = 'referral',
  ALL_TROPHIES = 'trophies',
  CHANGE_PASSWORD = 'change-password'
}
